import get from 'lodash.get';
import 'isomorphic-fetch';

export class ConfigError extends Error {
  constructor(msg, ...params) {
    const defaultMsg = 'An Error Occurred while trying to load config';
    super(`${defaultMsg}: ${msg}`, ...params);

    this.name = this.constructor.name;
  }
}

export const configLoad = async () => {
  try {
    const configPath = process.env.REACT_APP_CONFIG_LOCAL
      ? `/environments/sandbox/static/config/config.json?hash=${Math.random()}`
      : `/personal-investing/tools/nasu/static/config/config.json?hash=${Math.random()}`;

    const resp = await fetch(configPath);
    return resp.json();
  } catch (err) {
    const msg = 'An error occurred while trying to load config';
    // eslint-disable-next-line no-console
    console.error(msg, err);
    throw new ConfigError(err.message);
  }
};

let config = {};

export const initiateConfig = async () => {
  if (Object.keys(config).length === 0) {
    config = await configLoad();
  }
  return config;
};

const getConfig = (prop, fallback) => get(config, prop, fallback);

export default getConfig;

export const isDevelopment = () =>
  ['dev', 'sandbox'].includes(getConfig('environment'));

export const isProd = () => getConfig('environment') === 'prod';

export const isFrontOffice = () =>
  window.location.pathname.includes('front-office');
